module.exports = __webpack_public_path__ + "static/media/ribbon.8d489d00.svg";